import { Registration } from "../../client";

export default async (): Promise<Registration.Analytics> => {
  if (!import.meta.env.CLARITY_PROJECT_ID) return;

  const sessionId =
    new URLSearchParams(window.location.search).get("sessionId") || undefined;

  const Clarity = (await import("@microsoft/clarity")).default;

  Clarity.init(import.meta.env.CLARITY_PROJECT_ID);

  return {
    identify({ userId, properties }) {
      if (userId) Clarity.identify(userId, sessionId);
      if (properties) {
        for (const [key, value] of Object.entries(properties)) {
          Clarity.setTag(key, value);
        }
      }
    },
    track(name) {
      Clarity.event(name);
    },
    anonymize() {
      Clarity.identify("", undefined, undefined, undefined);
    },
  };
};
